import { render, staticRenderFns } from "./ModalGalery.vue?vue&type=template&id=5095f6d8"
import script from "./ModalGalery.vue?vue&type=script&lang=js"
export * from "./ModalGalery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports